export type ComboStepConfig = {
    step: 1 | 2 | 3
    type: string
    title: string
    shortTitle: string
}

export const RENACER_ALMA_NAME = 'Renacer del Alma'

export const RENACER_ALMA_PREAMBLE = {
    firstStepIntro:
        'Es la primera parte de un camino de renacimiento del alma (temporada actual → niño interior → yo futuro).',
    finalStepClosing:
        'cerrá el arco del combo mostrando cómo la temporada actual del alma, la sanación del niño interior y el yo futuro forman un mismo camino de renacimiento.',
}

export const RENACER_ALMA_STEPS: ComboStepConfig[] = [
    {
        step: 1,
        type: 'combo-renacer-temporada',
        title: 'Tirada de Temporada Actual del Alma',
        shortTitle: 'Temporada Actual del Alma',
    },
    {
        step: 2,
        type: 'combo-renacer-interior',
        title: 'Tirada de Sanación del Niño Interior',
        shortTitle: 'Sanación del Niño Interior',
    },
    {
        step: 3,
        type: 'combo-renacer-yo-futuro',
        title: 'Tirada de Conexión con tu Yo Futuro',
        shortTitle: 'Conexión con tu Yo Futuro',
    },
]

export const RENACER_ALMA_TOTAL_STEPS = RENACER_ALMA_STEPS.length
